<div class="container">
  <mat-card>
    <form [formGroup]="centerEditMeetingScheduleForm">
      <mat-card-content>
        <div fxLayout="column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Existing Meeting Date' | translate }}</mat-label>
            <mat-select formControlName="presentMeetingDate">
              <mat-option *ngFor="let date of nextMeetingDates" [value]="date">
                {{ date | dateFormat }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="centerEditMeetingScheduleForm.controls.presentMeetingDate.hasError('repeatsOnDay')">
              {{ 'labels.inputs.Existing Meeting Date' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field (click)="newMeetingDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Revised Meeting Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="newMeetingDatePicker"
              required
              formControlName="newMeetingDate"
            />
            <mat-datepicker-toggle matSuffix [for]="newMeetingDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #newMeetingDatePicker></mat-datepicker>
            <mat-error *ngIf="centerEditMeetingScheduleForm.controls.newMeetingDate.hasError('required')">
              {{ 'labels.inputs.Revised Meeting Date' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!centerEditMeetingScheduleForm.valid" (click)="submit()">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
